module.exports = __webpack_public_path__ + "img/bg65.d5b2ba21.png";